module.exports = __webpack_public_path__ + "lato-v23-latin-300italic.woff2";